import React, { useState, useEffect } from "react";
import { CiCheck, CiEdit, CiTrash } from "react-icons/ci"; // Example icons
import { useToast } from "../ToastContext";
import axios from "axios";
import Utils from "../../utils/utils";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

const ProjectSubmissionCard = ({ props }) => {
  const { submission, setSubmissions, project } = props;
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();
  const { Projects } = useAppLibs();
  //   const [isAssessed, setIsAssessed] = useState(submission.assessed);
  const [editMode, setEditMode] = useState(false);
  //  Marking Assessed
  const [marking, setMarking] = useState(false);
  const [submitted, setSubmitted] = useState(false); // Track submission result
  const [totalMarksObtained, setTotalMarksObtained] = useState(
    submission.totalMarksObtained ? submission.totalMarksObtained : 0
  );
  const [result, setResult] = useState(submission?.result || false);
  const [formData, setFormData] = useState({
    feedback: "",
  });

  // Handle the result fields
  const handleResultInput = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // MArking Assessed
  const HandleSubmissionAssessed = async (e) => {
    const confirm = window.confirm("Are you sure ? ");
    if (!confirm) return;

    // if (submission.assessed) {
    //   alert("This submission is already assessed .");
    //   return;
    // }

    e.preventDefault();
    if (!formData.feedback) {
      alert("Please add feedback before submitting.");
      return;
    }

    if (project?.maxMarks && totalMarksObtained) {
      if (project.maxMarks < totalMarksObtained) {
        showToast(
          "Marks can't be more than the maximum marks!",
          "warning",
          true,
          3000
        );
        return;
      }
    }
    formData["totalMarksObtained"] = totalMarksObtained;

    try {
      const response = await Projects.assessSubmission(
        submission._id,
        formData
      );
      const res = response.data;
      res["studentId"] = submission.studentId;
      setSubmissions((prev) =>
        prev.map((item) => (item._id === res._id ? res : item))
      );
      showToast("Submission has been assessed.", "success", true, 3000);
      setSubmitted(true);
      setMarking(false);
    } catch (error) {
      //   console.error("Error marking as assessed", error);
      showToast("Error marking as assessed", "error", true, 3000);
    } finally {
      setSubmitted(true);
      setMarking(false);
    }
  };

  useEffect(() => {
    setFormData({
      feedback: submission.feedback,
    });
  }, [submission]);

  return (
    <div
      bkl="ProjectSubmissionCard"
      className="p-4 border rounded-lg shadow-md bg-white"
      key={submission._id + submission.studentId}
    >
      <div className="flex justify-between items-center mb-4">
        <div>
          <h3 className="font-semibold text-lg">{submission.studentId.name}</h3>
          <p className="text-sm text-gray-500">
            Batch: {submission.studentId.batch}
          </p>
        </div>
        {submission?.totalMarksObtained >= 0 && (
          <div className="flex gap-2 items-center">
            <button disabled className="text-blue-500">
              <span>{submission.totalMarksObtained} Marks</span>
            </button>

            {/* <div className="flex justify-center">
              
              {result === "Cleared" && (
                <button
                  className={`px-5 py-2 uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-green-500 ${ResultBtnStyle.Cleared}`}
                >
                  Cleared
                </button>
              )}
              {result === "Partially Cleared" && (
                <button
                  className={`px-5 py-2 uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-yellow-500 ${ResultBtnStyle["Partially Cleared"]}`}
                >
                  Partially Cleared
                </button>
              )}
              {result === "Not Cleared" && (
                <button
                  className={`px-5 py-2 uppercase rounded-lg tracking-[0.5px] transition duration-200 border border-red-500 ${ResultBtnStyle["Not Cleared"]}`}
                >
                  Not Cleared
                </button>
              )}
            </div> */}
          </div>
        )}
      </div>

      <div className="flex gap-2 items-center">
        <a
          href={submission.submission || "#"}
          className={`${
            submission.submission
              ? "text-blue-600 underline"
              : "cursor-not-allowed text-red-500"
          }`}
          target={submission.submission ? "_blank" : ""}
          rel={submission.submission ? "noopener noreferrer" : ""}
          onClick={(e) => {
            if (!submission.submission) {
              e.preventDefault();
            }
          }}
        >
          {submission.submission || "Not Submitted"}
        </a>
      </div>

      <div className="mt-4 flex  items-center justify-between">
        <div className="flex gap-2 justify-end">
          <button
            onClick={() => setMarking(!marking)}
            className={`px-4 py-2 uppercase shadow-md tracking-[0.5px] hover:shadow-lg transition-all duration-200 hover:tracking-[1px] rounded-lg ${
              marking
                ? "text-orange-600 border border-orange-600"
                : "text-blue-600  border-blue-600 border"
            } `}
          >
            {marking
              ? "Cancel"
              : submission?.totalMarksObtained >= 0
              ? "Reassess"
              : "Mark Assessed"}
          </button>
          {marking && (
            <button
              onClick={HandleSubmissionAssessed}
              className={`px-6 py-2 rounded-lg  text-white uppercase ${
                formData.feedback
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
              disabled={!formData.feedback}
            >
              Submit Result
            </button>
          )}
        </div>
      </div>

      {marking && (
        <form className="space-y-4 mt-4 p-6 border rounded-md shadow">
          <div className="flex gap-2">
            {/* <div className="space-y-2 w-1/2">
              <label className="block text-sm font-medium text-gray-700">
                Select Result Status:
              </label>
              <select
                value={formData.result}
                name="result"
                onChange={handleResultInput}
                className="w-full px-3 py-2.5 text-sm border rounded-md focus:ring-pink-500 focus:border-pink-500"
              >
                <option value="" disabled>
                  Select Status
                </option>
                <option value="Cleared">Cleared</option>
                <option value="Partially Cleared">Partially Cleared</option>
                <option value="Not Cleared">Not Cleared</option>
              </select>
            </div> */}

            <div className="space-y-2  w-1/2">
              <label className="block text-sm font-medium text-gray-700">
                Marks Obtained:
              </label>
              <input
                type="tel"
                placeholder="Marks Obtained"
                value={totalMarksObtained}
                pattern="[0-9]*"
                inputMode="numeric"
                name="setTotalMarksObtained"
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setTotalMarksObtained(value);
                  } else {
                    alert("Please enter numbers only.");
                    return false;
                  }
                }}
                className=" max-w-[120px] px-3 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Provide Feedback:
            </label>
            <textarea
              value={formData.feedback}
              name="feedback"
              onChange={handleResultInput}
              placeholder="Write your feedback here..."
              rows={2}
              className="w-full px-4 py-3 text-sm border rounded-md focus:ring-pink-500 focus:border-pink-500 focus:outline-none"
            />
          </div>

          {/* Feedback Message */}
          {submitted && (
            <div className="text-green-600 font-medium mt-4">
              Result has been submitted successfully!
            </div>
          )}
        </form>
      )}
    </div>
  );
};

export default ProjectSubmissionCard;
